<template lang="pug">
#container--body-insurance.formalities
  v-layout#formalities(align-center v-if="!processFinished")
    v-flex#form-formalities
      v-window.elevation-1(v-model="stepTransact" horizontal touchless)
        //- PASO 1: SOLICITUD
        v-window-item
          v-card(flat)
            v-card-text
              v-layout.text-xs-center.text-md-center(align-center wrap)
                v-flex(xs1 sm12 md1 lg1)
                v-flex.text-xs-center.text-md-center(xs10 sm12 md10 lg10)
                  //- STEPPERS ARRIBA DE TODO
                  .stepper-container-center
                    .stepper-wrapper-compact
                      .stepper-item-compact
                        .stepper-item-contain
                          img(:src="stepTransact === 0 ? stepperIcons.oneActive : stepperIcons.oneChecked" alt="Solicitud" style="width: 40px;")
                        span.stepper-text(:class="{ active: stepTransact === 0 }") Solicitud
                      .stepper-line-compact
                      .stepper-item-compact
                        .stepper-item-contain
                          img(:src="stepTransact === 1 ? stepperIcons.twoActive : stepperIcons.twoDisabled" alt="Resumen" style="width: 40px;")
                        span.stepper-text(:class="{ active: stepTransact === 1 }") Resumen
                  
                  v-layout.text-xs-center.text-md-center(align-center wrap)
                    v-flex.text-xs-center.text-md-center(xs12 sm12 md12 lg12)
                      v-layout
                        //- PANEL MI PRODUCTO
                        v-flex(xs0 sm0 md4 lg4)
                          PanelSOATProduct(
                            :product="form.product"
                            :policy="form.policy"
                            request-type="Anulación de póliza"
                          )
                        
                        //- PANEL MI SOLICITUD - PASO 1
                        v-flex(xs12 sm12 md4 lg4)
                          FormSOATCancellation(
                            :cancellation-reasons="cancelationReasons"
                            :cancellation-reason.sync="form.cancellation_reason"
                            :email.sync="form.email"
                            :is-disabled="isStep1Disabled"
                            @continue="handleContinueToSummary"
                            @go-to-profile="navigateTo('/mi-perfil')"
                            @go-back="navigateTo('/solicitudes')"
                          )
                        
                        //- ESPACIO
                        v-flex(xs0 sm0 md4 lg4)
                v-flex(xs1 sm12 md1 lg1)
        
        //- PASO 2: RESUMEN
        v-window-item
          v-card(flat)
            v-card-text.tramite
              v-layout(wrap)
                v-flex(xs0 sm0 md3 lg4)
                v-flex(xs12 sm12 md6 lg4)
                  StepSOATCancellationSummary(
                    :policy="form.policy"
                    :product="form.product"
                    :number-document="form.number_document"
                    :cancellation-reason="form.cancellation_reason"
                    :is-disabled="false"
                    :loader="loader"
                    @confirm="confirmCancellation"
                    @go-back="stepTransact = 0"
                  )
                v-flex(xs0 sm0 md3 lg4)
  
  //- CONFIRMACIÓN FINAL
  .last-step(v-if="processFinished")
    StepSOATCancellationSuccess(
      :request-number="numCode"
      :policy="form.policy"
      :product="form.product"
      :cancellation-reason="form.cancellation_reason"
      @go-home="navigateTo('/inicio')"
    )

  //- LOADER
  v-dialog(v-model="loader" persistent width="300")
    v-card(color="primary" dark)
      v-card-text
        | Procesando solicitud...
        v-progress-linear.mb-0(indeterminate color="white")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { SOAT_CANCELLATION_REASONS, FORMALITY_TYPES, API_RESPONSE_CODES, HTTP_STATUS } from '@/constants'
import { SOAT_STEPPER_ICONS } from '@/constants/soatAssets'
import { initForm, prepareDataV2, validateForm } from '@/services/soat-cancellation.service'
import trackingMixin from '@/mixins/trackingMixin'
import PanelSOATProduct from '@/components/soat/PanelSOATProduct.vue'
import FormSOATCancellation from '@/components/soat/FormSOATCancellation.vue'
import StepSOATCancellationSummary from '@/components/soat/StepSOATCancellationSummary.vue'
import StepSOATCancellationSuccess from '@/components/soat/StepSOATCancellationSuccess.vue'

export default {
  name: 'FormalitiesSOATCancellation',
  components: {
    PanelSOATProduct,
    FormSOATCancellation,
    StepSOATCancellationSummary,
    StepSOATCancellationSuccess
  },
  mixins: [trackingMixin],
  props: {
    policy: {
      type: String,
      default: null
    },
    product: {
      type: String,
      default: 'SOAT'
    }
  },
  
  data() {
    return {
      stepTransact: 0,
      processFinished: false,
      loader: false,
      numCode: null,
      stepperIcons: SOAT_STEPPER_ICONS,
      form: initForm(null, this.policy || this.$route.params.policy),
      cancelationReasons: SOAT_CANCELLATION_REASONS
    }
  },
  
  computed: {
    ...mapGetters('user', ['polizasInfo', 'userInfo', 'basicInfo']),
    
    /**
     * Obtiene el número de póliza desde múltiples fuentes con prioridad.
     * Evita duplicación de lógica en múltiples métodos.
     * @returns {string} Número de póliza
     */
    policyNumber() {
      return this.form.policy || this.policy || this.$route.params.policy || ''
    },
    
    /**
     * Valida si el paso 1 está completo para habilitar botón Continuar.
     * @returns {boolean} true si faltan campos obligatorios
     */
    isStep1Disabled() {
      return !this.form.cancellation_reason || !this.form.email
    }
  },
  
  watch: {
    basicInfo: {
      handler(newVal) {
        if (newVal) {
          this.initializeForm()
        }
      },
      immediate: true
    }
  },
  
  async mounted() {
    this.trackPageview('/solicitudes-soat', 'Anulación SOAT')
    await this.validatePendingRequest()
  },
  
  methods: {
    ...mapActions('user', ['sendTransactSOAT']),
    ...mapActions('formalities', ['registerFormality', 'registerRequirements']),
    ...mapActions('requirements', ['checkIfPolicyHasPending']),
    
    initializeForm() {
      if (!this.basicInfo) return
      
      this.form = initForm(this.basicInfo, this.policyNumber)
    },
    
    /**
     * Maneja el avance al paso 2 (resumen).
     * Valida campos obligatorios antes de continuar.
     */
    handleContinueToSummary() {
      if (!this.form.cancellation_reason || !this.form.email) {
        return
      }
      this.stepTransact = 1
    },
    
    async validatePendingRequest() {
      try {
        if (!this.policyNumber) {
          return
        }
        
        const response = await this.checkIfPolicyHasPending({ numeroPoliza: this.policyNumber })
        
        if (response && response.data && response.data.data) {
          const pendingCancellations = response.data.data.filter(
            req => req.transact === 'Anulación de póliza' && req.state === 'PENDIENTE'
          )
          
          if (pendingCancellations.length > 0) {
            this.$swal({
              title: '¡Solicitud de anulación en evaluación!',
              text: 'Estamos evaluando tu solicitud anterior. Podrás iniciar una nueva en cuanto finalice el proceso actual.',
              imageUrl: require('@/assets/characters/oops.svg'),
              imageHeight: 180,
              imageWidth: 180,
              confirmButtonText: 'Entendido'
            }).then(() => {
              this.navigateTo('/inicio')
            })
          }
        }
      } catch (error) {
        // Log genérico sin información sensible
        console.error('[SOAT Cancellation] Error validating pending request')
      }
    },
    
    async confirmCancellation() {
      try {
        // Guard clause: prevenir múltiples submits
        if (this.loader) return
        
        this.loader = true
        
        // Validar formulario antes de enviar
        const validation = validateForm(this.form)
        if (!validation.isValid) {
          this.loader = false
          this.$swal({
            title: 'Datos incompletos',
            text: 'Por favor, completa todos los campos requeridos correctamente.',
            imageUrl: require('@/assets/formpp/atencion-1.svg'),
            imageHeight: 180,
            imageWidth: 180,
            confirmButtonText: 'Entendido'
          })
          return
        }
        
        const data = prepareDataV2(this.form)
        const response = await this.registerRequirements(data)
        
        if (response && response.status === HTTP_STATUS.OK && response.data) {
          if (response.data.codigoRespuesta === API_RESPONSE_CODES.DUPLICATE_REQUEST) {
            this.loader = false
            this.$swal({
              title: '¡Lo sentimos!',
              text: 'Ya tienes una solicitud de anulación de póliza en proceso. Por favor, espera a que sea procesada antes de crear una nueva.',
              imageUrl: require('@/assets/characters/sorprendido.svg'),
              imageHeight: 180,
              imageWidth: 180,
              confirmButtonText: 'Entendido'
            }).then(() => {
              this.navigateTo('/inicio')
            })
            return
          }
          
          if (response.data.codigoRespuesta === API_RESPONSE_CODES.SUCCESS) {
            this.numCode = response.data.numero_requerimiento || null
            this.loader = false
            this.processFinished = true
            
            this.trackSOATSuccess({
              action: 'Anulación SOAT - Solicitud Enviada',
              policy: this.policyNumber,
              requestCode: this.numCode
            })
          } else {
            throw new Error(response.data.mensajeRespuesta || 'Error al procesar la solicitud')
          }
        } else {
          throw new Error('Error al procesar la solicitud')
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    
    handleError(error) {
      this.loader = false
      
      this.$swal({
        title: 'Atención',
        text: 'Tuvimos inconvenientes al enviar tu solicitud, revisa tu conexión a internet e inténtalo de nuevo.',
        imageUrl: require('@/assets/formpp/atencion-1.svg'),
        imageHeight: 180,
        imageWidth: 180,
        confirmButtonText: 'Entendido'
      })
      
      // Log genérico sin datos sensibles
      console.error('[SOAT Cancellation] Error processing request')
      
      // Tracking sin información sensible
      this.trackSOATError({
        action: 'Anulación SOAT',
        policy: this.policyNumber,
        errorType: error.name || 'UnknownError'
      })
    },
    
    navigateTo(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
@import url("../../assets/css/general.css");
@import url("../../styles/soat-stepper.css");

/* LAYOUT PRINCIPAL */
#container--body-insurance.formalities { 
  padding: 0; 
  width: 100%;
}

#formalities {
  width: 100%;
}

#form-formalities { 
  width: 100%; 
}

#formalities .flex .v-window.elevation-1 { 
  box-shadow: none!important; 
}

#formalities, #formalities .flex .v-window.elevation-1 .v-window__container {
  height: auto;
  min-height: calc(100vh - 54.55px);
  width: 100%;
}

#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text {
  background-color: #FFF;
  padding: 0;
  width: 100%;
}

#form-formalities .v-window .v-window__container .v-window-item .v-card {
  width: 100%;
}

#form-formalities .v-window .v-window__container .v-window-item {
  width: 100%;
}

/* CARD TEXT TRAMITE */
.tramite {
  padding: 40px 0 !important;
  background: #FFF;
  width: 100% !important;
  max-width: 100vw !important;
}

.tramite .layout {
  width: 100%;
}

/* LAST STEP */
.last-step {
  background: #FFF;
  padding: 40px 0;
}
</style>





// WEBPACK FOOTER //
// src/pages/soat/FormalitiesSOATCancellation.vue